import React, { useEffect } from 'react';
import {
  BackNavAdmin,
  ChallengeInfoDetails,
  ChallengeInfoAwardsCard,
  ChallengeSchedule,
  ChallengeIdeaTable,
  DialogAllCreateIdea,
  BackNavAdminMenus,
  BackNavAdminButtons,
} from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import {
  challengeActions,
  ideaCreateDialogsActions,
  ideaCreateActions,
} from '../../actions';
import { useParams } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles,
  CardMedia,
  Card,
  CardContent,
  CircularProgress,
  useTheme,
} from '@material-ui/core';
import imageCard from '../../assets/imgs/imagem_padrao_card_desafio.png';
import { useTranslation } from 'react-i18next';
import { ChallengeRankCard } from '../../components/Challenge/ChallengeRankCard';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3),
  },
  containerLoading: {
    marginTop: theme.spacing(30),
    display: 'flex',
    justifyContent: 'center',
  },
  media: {
    height: 246,
    backgroundColor: theme.palette.neutrals.low.light,
    borderRadius: 8,
    marginBottom: theme.spacing(3)
  },
}));

function ChallengeDetailPage() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { id } = useParams();
  const {
    challengeDetail,
    challengeTableIdeas: { ideas, paging },
  } = useSelector((state) => state.challenge);
  const {
    typeProfile: { type },
  } = useSelector((state) => state.user);
  const classes = useStyles();
  const { t } = useTranslation();


  useEffect(() => {
    dispatch(challengeActions.getChallengeById(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    if (type === 'colaborator') {
      dispatch(challengeActions.setFilterColaborator());
      const status = [
        'CONCLUDED',
        'PATENT_PENDING',
        'EXECUTION_QUEUE',
        'EXECUTION',
        'QUALIFIED',
      ];

      dispatch(
        challengeActions.getIdeasChallenge(
          id,
          1,
          paging.sort,
          paging.limit,
          status
        )
      );
    } else {
      const status = [
        'CONCLUDED',
        'PATENT_PENDING',
        'EXECUTION_QUEUE',
        'EXECUTION',
        'QUALIFIED',
        'AWAITING_QUALIFICATION',
        'EXECUTING'
      ];
      dispatch(
        challengeActions.getIdeasChallenge(
          id,
          1,
          paging.sort,
          paging.limit,
          paging.statusCode
        )
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function createIdea() {
    const challenge = {
      _id: challengeDetail._id,
      name: challengeDetail.name,
      createdAt: challengeDetail.createdAt,
      status: true,
    };

    dispatch(ideaCreateActions.setChallenge(challenge));
    dispatch(ideaCreateActions.setIdeaCreateChallenge());
    dispatch(ideaCreateDialogsActions.openDialogTitleDescription());
  }

  const orangeChallengeUrl = 'https://imagine-files.imagineinovacao.com.br/dexco/Desafio-Imagine-01-2022._890add3e-3468-413f-b0fe-05f86d390258.jpeg';
  const orangeChallengeUrlCustom = 'https://imagine-files.imagineinovacao.com.br/dexco/Desafio-Imagine-Cover._42aab111-d01b-45a1-b473-7f030222e8c0.jpeg';

  const imageUrl = () => {
    if (challengeDetail.attachment.url === orangeChallengeUrl) {
      return orangeChallengeUrlCustom;
    } else {
      return challengeDetail.attachment.url;
    };
  };



  return (
    <div>
      <DialogAllCreateIdea challenge />

      {
        (challengeDetail._id != id) ? (
          <>
            <BackNavAdmin title={t('carregando...')} pathname="/challenges">
            </BackNavAdmin>
            <Container maxWidth="lg" className={classes.containerLoading}>
              <CircularProgress />
            </Container>
          </>
        ) : (
          <>
            <BackNavAdmin title={challengeDetail.name} pathname="/challenges">
              <BackNavAdminButtons type={type} id={id} createIdea={createIdea} />
            </BackNavAdmin>
            <BackNavAdminMenus type={type} id={id} status={challengeDetail} createIdea={createIdea} />
            <Container maxWidth="lg" className={classes.container}>
              <CardMedia
                className={classes.media}
                image={
                  challengeDetail?.attachment?.url
                    ? imageUrl()
                    : imageCard
                }
              />
              <Grid container spacing={3}>
                <Grid item xs={12} lg={8}>
                  <Card>
                    <CardContent>
                      <Grid item xs={12}>
                        {challengeDetail && (
                          <ChallengeInfoDetails challenge={challengeDetail} />
                        )}
                      </Grid>

                      <Grid item xs={12}>
                        <ChallengeSchedule challenge={challengeDetail} />
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
 
                <Grid item xs={12} lg={4}>
                  {challengeDetail?.rewards?.every(reward => reward.win) && <ChallengeRankCard challenge={challengeDetail} />}
                  <ChallengeInfoAwardsCard challenge={challengeDetail} />
                </Grid>
              </Grid>

              {ideas && ideas.length > 0 && (
                <Grid container>
                  <Grid item xs={12}>
              <hr style={{ marginTop: 40, border: `1px solid ${theme.palette.secondary.lightest}` }} />
                    <ChallengeIdeaTable
                      ideas={ideas}
                      paging={paging}
                      id={id}
                      userRule={type}
                    ></ChallengeIdeaTable>
                  </Grid>
                </Grid>
              )}
            </Container>
    

        </>
    
 
    )}
   </div>
);
}
export { ChallengeDetailPage };
